export default __webpack_public_path__ + "static/media/010-seagull-1.763c5ee1.png";